export const getEPSGCode = (zoneNumber: number | null, hemisphere: 'N' | 'S'): number | null => {
  if (zoneNumber === null || zoneNumber < 1 || zoneNumber > 60) {
    return null
  }
  if (hemisphere === 'N') {
    return 32600 + zoneNumber
  }
  if (hemisphere === 'S') {
    return 32700 + zoneNumber
  }
  return null
}
